var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.667 558.666H81V749.999H208.667V558.666Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M718.999 303.666H591.332V749.999H718.999V303.666Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M463.999 431H336.332V750H463.999V431Z",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 750H782.665",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.332 271.667H415.999C428.641 271.667 440.765 266.645 449.704 257.706C458.643 248.767 463.665 236.643 463.665 224.001C463.709 217.713 462.509 211.479 460.133 205.657C457.757 199.835 454.253 194.541 449.823 190.08C445.392 185.618 440.122 182.077 434.317 179.661C428.512 177.244 422.286 176 415.999 176.001H382.665C370.023 176.001 357.899 170.979 348.96 162.039C340.021 153.1 334.999 140.976 334.999 128.334C334.998 115.661 340.01 103.502 348.94 94.5102C357.869 85.5179 369.993 80.422 382.665 80.334H494.332",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400 16.666V80.3327",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400 271.666V335.666",
    stroke: "white",
    strokeWidth: 63.6667,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialGrowth);
export default __webpack_public_path__ + "static/media/financial-growth.821c3c672da7e60669af5105d18ae34f.svg";
export { ForwardRef as ReactComponent };